// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import { ServerTable } from 'vue-tables-2'

// todo
// cssVars()

Vue.use(BootstrapVue)
Vue.use(ServerTable)
window.axios = require('axios')

// axios全局配置
axios.defaults.withCredentials = true
axios.defaults.crossDomain = true

// 相应为303时重定向到CAS
axios.interceptors.response.use((response) => {
  console.log('statusCode: ' + response.data.statusCode)
  if (response && response.data) {
    if (response.data.statusCode === 303) {
      window.location.href = response.data.data
    } else {
      return response
    }
  } else {
    return response
  }
});

// 获取配置文件
axios.get(document.location.origin + '/config/' + 'config.json').then(response => {
  // 获取用户信息
  axios.get(response.data.backendUrl + '/user').then(response2 => {
    console.log(JSON.stringify(response2.data))
    // 用户获取失败，返回首页
    if (response2.data.errorCode === 1001) {
      window.location.href = "/"
    }
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      template: '<App/>',
      components: {
        App
      },
      data: function() {
        return {
          userInfo: response2.data
        }
      },
      beforeCreate: function() {
        axios.backendUrl = response.data.backendUrl
        axios.androidBackendUrl = response.data.androidBackendUrl
        console.log('backendUrl = ' + axios.backendUrl)
        console.log('androidBackendUrl = ' + axios.androidBackendUrl)

      }
    })
  })

})


